<template>
  <page>
    <div ref="head" slot="head" class="page-head-default">
      <img class="menu" src="../assets/imgs/menu.png" alt="" @click="isMenuView = true" />
      {{ title }}
      <img class="home" src="../assets/imgs/home.png" alt="" @click="goHome" />
    </div>
    <div>
      <div class="home-warp" v-if="isView">
        <div ref="banner" class="banner" :style="banner"></div>
        <div class="home-warp-main" :style="'height:' + mainHeight + 'px;'">
          <div class="home-warp-block"></div>
          <div class="home-warp-title">
            <img src="../assets/imgs/map.png" alt="" />
            <span>{{ cabinet.shopname }}</span>
          </div>
          <div class="home-warp-cont">
            <div v-if="!isH5DoMain" class="home-warp-jifei">
              <span>{{ cabinet.currencyName }}{{ cabinet.jifei }}</span
              >/{{ cabinet.jifeiDanwei }}{{ i18n.minute }}
            </div>
            <div class="home-warp-tip" v-if="user && vipTypes.includes(user.vip_name)">{{ i18n.price_info2 }}</div>
            <div class="home-warp-tip" v-else-if="!isH5DoMain">
              <span>{{ shopDesc }}</span>
              <span>{{ shopDesc1 }}</span>
              <span>{{ shopDesc3 }}</span>
            </div>
            <div class="home-warp-col" v-else>
              <h3>{{ i18n.price_info4_title }}</h3>
              <p>{{ shopDesc4 }}</p>
            </div>
            <template v-if="!isH5DoMain">
              <div class="home-warp-row">
                <img src="../assets/imgs/icon_phone.png" alt="" />
                {{ i18n.feature_1 }}
              </div>
              <div class="home-warp-row">
                <img src="../assets/imgs/icon_star.png" alt="" />
                {{ i18n.feature_2 }}
              </div>
              <div class="home-warp-row">
                <img src="../assets/imgs/icon_tag.png" alt="" />
                {{ i18n.feature_3 }}
              </div>
            </template>
            <template v-else>
              <div class="home-warp-col">
                <h3>{{ i18n.feature_4_title }}</h3>
                <p>{{ featureRow4 }}</p>
              </div>
              <div class="home-warp-col">
                <h3>{{ i18n.feature_5_title }}</h3>
                <p>{{ featureRow5 }}</p>
              </div>
              <div class="home-warp-col">
                <h3>{{ i18n.feature_6_title }}</h3>
                <p>{{ featureRow6 }}</p>
              </div>
            </template>
          </div>
          <div
            class="home-warp-btn"
            v-if="user && vipTypes.includes(user.vip_name)"
          >
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ i18n.tips_5 }}</span>
            </div>
            <div class="btn" @click="onVIP">{{ i18n.borrow }}</div>
            <div class="page-footer">@ HK Chargeeasy Ltd</div>
          </div>
          <div class="home-warp-btn" v-else-if="
              cabinet.myyue >= cabinet.yajin &&
                cabinet.myyue >= cabinet.fengding
            ">
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips3 }}</span>
            </div>
            <div class="btn" @click="onBorrow">{{ i18n.borrow }}</div>
            <div class="page-footer">@ HK Chargeeasy Ltd</div>
          </div>
          <div
            class="home-warp-btn"
            v-else
          >
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips1 }}</span>
            </div>
            <div class="btn" @click="onSubmit">{{ i18n.submit }}</div>
            <div class="page-footer">@ HK Chargeeasy Ltd</div>
          </div>
        </div>
      </div>
      <div class="home-body">
        <div class="map-container" v-if="browser === 'mpay'">
          <div class="huawei-map" id="huawei-map"></div>
        </div>
        <!-- <div class="map-container" v-else-if="browser !== 'mpay'">
          <div class="google-map" id="google-map"></div>
        </div> -->
        <div v-else-if="!isView">
            <img
            v-if="inviteCode"
            class="home-bg"
            src="../assets/imgs/home_bg.jpeg"
            alt=""
          />
          <img
            v-else-if="lang === 'en-US'"
            class="home-bg"
            src="../assets/imgs/home_bg_en.jpeg"
            alt=""
          />
          <img v-else class="home-bg" src="../assets/imgs/home_bg2.jpg" alt="" />
        </div>
        <div class="home-foot" v-if="browser !== 'mpay'">
          <div class="home-foot-tips">{{ i18n.download_app }}</div>
          <div class="home-btns">
            <div
              v-if="system === 'ios'"
              class="appstore"
              @click="onAppStore"
            >
              <img src="../assets/imgs/apple.png" alt="" />
              <span>App Store</span>
            </div>
            <div v-else class="googlepaly" @click="onGooglePlay">
              <img src="../assets/imgs/icon_android.png" alt="" />
              <!-- <img src="../assets/imgs/google.png" alt="" /> -->
              <span>Direct download</span>
            </div>
            <!-- <div v-else class="hwstore" @click="onHuaWeiPlay">
              <img src="../assets/imgs/huawei.png" alt="" />
              <span>HUAWEI Store</span>
            </div> -->
            <div v-if="browser === 'mpay' && code" @click="onCode">
              <span>{{ i18n.goborrow }}</span>
            </div>
          </div>
          <div class="page-footer">@ HK Chargeeasy Ltd</div>
        </div>
        <img class="icon_home_location" v-if="browser === 'mpay'" src="../assets/imgs/icon_home_location.png" @click="moveMap">
        <div class="home_scan" v-if="browser === 'mpay'">
          <img class="icon_home_scan" src="../assets/imgs/icon_home_scan.png">
          <h3 class="home_scan_btn" @click="scanQRCode">掃碼充電</h3>
        </div>
      </div>
      <popup-warp v-model="isMenuView" dialogTransition="slide-left">
        <menu-side></menu-side>
      </popup-warp>
    </div>
    <div v-if="browser === 'wechat'" class="openothermask">
      <img src="../assets/imgs/arrow.png">
      <p>{{i18n.wechat_download_tips}}</p>
    </div>
    <!-- <paytype v-if="payTypeShow" ref="paytype" :pPrice="cabinet.myyue < cabinet.fengding ? cabinet.myyajin : cabinet.myyue" :payTypeShow="payTypeShow" @back="onBack" @changeRadio="changeRadio" @goPay="goPay" /> -->
  </page>
</template>

<script>
import { PopupWarp } from '../components/popup'
import { MenuSide } from '../components/menu'
import { mapState } from 'vuex'
import { QR_CODE, ZH_CODE, SHOP_LIST } from '../apis/cabinet'
import { YEDPAY_PREPAY_RENT, EFT_PREPAY_RENT, CREATE_VIP_ORDER, MPAY_RENT } from '../apis/payment'
import { USER_INFO, OEDER_COUNT } from '../apis/user'
import { baseURL } from '../utils/http'
import logoIcon from '../assets/imgs/marker.png'
let gMapContext
export default {
  components: {
    PopupWarp,
    MenuSide
  },
  watch: {
    isMenuView (val, oldval) {
      // console.log('val', val)
      val ? this.openTouch() : this.closeTouch()
    },
    isView (val, oldval) {
      if (val) {
        this.loadHeight()
      }
    },
    markerList () {
      if (gMapContext) {
        this.setMarkerList()
      }
    }
  },
  computed: {
    ...mapState([
      'qrcode',
      'zhcode',
      'cabinet',
      'browser',
      'user',
      'system',
      'lang',
      'inviteCode',
      'ismobile'
    ]),
    i18n () {
      return this.$t('home')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    title () {
      return process.env.VUE_APP_NAME
    },
    code () {
      return this.qrcode || this.zhcode
    },
    scanUrl () {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}`
      }
      if (this.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`
      }
      return ''
    },
    banner () {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : ''
    },
    shopDesc () {
      return `${this.i18n.price_info}`.format(this.cabinet)
    },
    shopDesc1 () {
      return `${this.i18n.price_info1}`.format(this.cabinet)
    },
    shopDesc3 () {
      return `${this.i18n.price_info3}`.format(this.cabinet)
    },
    shopDesc4 () {
      return `${this.i18n.price_info4}`.format(this.cabinet)
    },
    shopTips1 () {
      return `${this.i18n.tips_1}`.format(this.cabinet)
    },
    shopTips2 () {
      return `${this.i18n.tips_2}`.format(this.cabinet)
    },
    shopTips3 () {
      if (this.cabinet.myyue < this.cabinet.fengding) {
        return `${this.i18n.tips_4}`.format(this.cabinet)
      } else {
        return `${this.i18n.tips_3}`.format(this.cabinet)
      }
    },
    featureRow4 () {
      return `${this.i18n.feature_4}`.format(this.cabinet)
    },
    featureRow5 () {
      return `${this.i18n.feature_5}`.format(this.cabinet)
    },
    featureRow6 () {
      return `${this.i18n.feature_6}`.format(this.cabinet)
    },
    amount () {
      if (this.cabinet) {
        return this.cabinet.yajin - this.cabinet.myyue
      } else {
        return 0
      }
    },
    isView () {
      return this.isScan && this.cabinet && !this.isBtns
    },
    isH5DoMain () {
      console.log(baseURL)
      return baseURL.indexOf('h5.easycharge') !== -1
      // return true
    }
  },
  data () {
    return {
      isMenuView: false,
      isScan: false,
      isBtns: false,
      mainHeight: 400,
      ua: navigator.userAgent.toLowerCase(),
      markerList: [],
      oldMarkerList: [],
      latitude: '', // 48.856613
      longitude: '', // 2.352222
      pay: process.env.VUE_APP_PAY === '1',
      vipTypes: ['VIP会员', '双月通会员', '全年通贵宾', '季度通会员']
      // payTypeShow: false,
      // payTypeValue: 1
    }
  },
  methods: {
    onScan () {
      if (!this.scanUrl) return
      this.$loading(true)
      this.$post(
        this.scanUrl,
        {},
        resp => {
          this.$loading(false)
          this.$store.commit('cabinet', {
            qrcode: this.code,
            ...resp
          })
          this.isScan = true
        },
        error => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onSubmit () {
      this.$router.push({
        path: '/wallet',
        query: { qrcode: this.cabinet.qrcode, amount: this.amount }
      })
    },
    onBorrow () {
      this.$loading(true)
      let url = this.browser === 'mpay' ? `${MPAY_RENT}?qrcode=${this.cabinet.qrcode}` : `${this.pay ? EFT_PREPAY_RENT : YEDPAY_PREPAY_RENT}?qrcode=${this.cabinet.qrcode}`
      this.$post(
        url,
        {},
        resp => {
          this.$loading(false)
          // console.log(resp)
          if (resp.data && resp.data.outTradeNo) {
            this.$router.push(`/result?tradeNo=${resp.data.outTradeNo}`)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        error => {
          this.$loading(false)
          // console.log(error)
          this.$toast(error)
        }
      )
    },
    onVIP () {
      this.$loading(true)
      this.$post(
        `${CREATE_VIP_ORDER}/${this.cabinet.qrcode}`,
        {},
        resp => {
          this.$loading(false)
          // console.log(resp)
          if (resp.orderid) {
            this.$router.push(`/result?tradeNo=${resp.orderid}`)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        error => {
          this.$loading(false)
          // console.log(error)
          this.$toast(error)
        }
      )
    },
    loadUser () {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit('user', resp.user)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              showOk: false,
              // confirmText: this.i18nMsg.retry,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        error => {
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            showOk: false,
            // confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    },
    onAppStore () {
      window.location.href = process.env.VUE_APP_APP_STORE
    },
    onGooglePlay () {
      window.location.href = process.env.VUE_APP_GOOGLE_PLAY
    },
    onHuaWeiPlay () {
      window.location.href = process.env.VUE_APP_HUAWEI_PLAY
    },
    onCode () {
      if (this.user) {
        this.isBtns = false
        this.loadUser()
        this.onScan()
      } else {
        this.$router.push('/login')
      }
    },
    closeTouch () {
      let node = document.getElementsByTagName('body')[0]
      node.style.overflow = 'hidden'
      document
        .getElementsByTagName('body')[0]
        .addEventListener('touchmove', this.handler, { passive: false }) // 阻止默认事件
    },
    openTouch () {
      let node = document.getElementsByTagName('body')[0]
      node.style.overflow = 'auto'
      document
        .getElementsByTagName('body')[0]
        .removeEventListener('touchmove', this.handler, { passive: false }) // 打开默认事件
    },
    handler (e) {
      e.preventDefault()
    },
    loadHeight () {
      this.$nextTick(() => {
        this.mainHeight =
          document.documentElement.clientHeight -
          this.$refs.banner.clientHeight -
          this.$refs.head.clientHeight +
          10
        this.loadHeight = () => {}
      })
    },
    getOrderCount () {
      this.$get(
        OEDER_COUNT,
        {},
        resp => {
          if (resp.noMoney) {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.i18nMsg.unpaid_order,
              confirmText: this.i18nMsg.go_pay,
              showCancel: false
            }).then(() => {
              this.$router.push('/order')
            })
          }
        },
        error => {
          console.log(error)
        }
      )
    },
    initMap () {
      let center = { lat: Number(this.latitude), lng: Number(this.longitude) }
      if (document.getElementById('huawei-map') && this.browser === 'mpay') {
        this.times = 0
        gMapContext = null
        console.log('huaweimap context')
        console.log('zheli', Number(this.latitude), Number(this.longitude))
        // The location of Uluru
        const mapOptions = {
          center: center,
          zoom: 16,
          language: 'zh',
          sourceType: 'RASTER',
          mapType: 'ROADMAP'
        }
        gMapContext = new HWMapJsSDK.HWMap(
          document.getElementById('huawei-map'),
          mapOptions
        )
        gMapContext.setLogoPosition('TOP_LEFT')
        // 為地圖添加地圖移動結束事件
        // gMapContext.on('moveend', this.mapCenterChanged)
        this.setMarkerList()
        console.log('huaweimap success')
      } else {
        // this.times++
        gMapContext = new google.maps.Map(document.getElementById('google-map'), {
          center: center,
          zoom: 15,
          mapTypeId: 'roadmap'
        })
        this.setMarkerList()
        // console.log('huaweimaptimeout')
        // setTimeout(this.initMap, 500 * this.times)
      }
    },
    createScript () {
      let oscript = document.createElement('script')
      // let that = this
      // console.log('asdfasdfsafdsfasdfsdfs')
      oscript.id = 'hwapiscript'
      oscript.src = `https://mapapi.cloud.huawei.com/mapjs/v1/api/js?callback=initMap&key=${encodeURIComponent(`CV73M+Hc3nq3ncHY7qU3w76fX0G1xXZ0Ht9bC0RaVBpSE8Q0VARcfCbiiw6Zhp5kkakHpxd7hO1Fz4qXNe4mWgQaZHBB`)}`
      let head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
      head.insertBefore(oscript, head.firstChild)
    },
    createGScript () {
      let gscript = document.createElement('script')
      // let that = this
      // console.log('asdfasdfsafdsfasdfsdfs')
      gscript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBuwzyOxgruOOVn8VDTqkouTS5iNKV9QiU&callback=initMap'
      gscript.async = true
      let head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
      head.insertBefore(gscript, head.firstChild)
    },
    getMapMarkListOption () {
      this.$post(SHOP_LIST, {
        coordType: 'WGS-84',
        zoomLevel: 5,
        lat: this.latitude,
        lng: this.longitude
      }, resp => {
        // console.log(resp)
        this.markerList = resp.list
      }, err => {
        console.log(err)
      })
    },
    setMarkerList () {
      this.oldMarkerList.map(item => {
        item.setMap(null)
        item = null
      })
      if (this.markerList && this.markerList.length > 0) {
        if (this.browser === 'mpay') {
          this.oldMarkerList = this.markerList.map(obj => {
            return new HWMapJsSDK.HWMarker({
              map: gMapContext,
              position: { lat: parseFloat(obj.latitude), lng: parseFloat(obj.longitude) },
              zIndex: 10,
              label: {
                text: '',
                offsetY: -30,
                fontSize: '10px'
              },
              icon: {
                scale: 0.5,
                opacity: 1,
                url: logoIcon
              }
            })
            // .addListener('click', this.clickMarker)
          })
        } else {
          this.oldMarkerList = this.markerList.map(obj => {
            return new google.maps.Marker({
              position: { lat: parseFloat(obj.latitude), lng: parseFloat(obj.longitude) },
              map: gMapContext,
              icon: {
                url: logoIcon,
                scaledSize: new google.maps.Size(40, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 30)
              }
            })
            // .addListener('click', this.clickMarker)
          })
        }
      }
    },
    mpReady () {
      let that = this
      if (window.mp) {
        window.mp.getLocation({
          type: 'WGS84',
          success: (res) => {
            console.log('mpay定位', res)
            that.latitude = res.latitude // 緯度，浮點數，範圍為 90 ~ -90
            that.longitude = res.longitude // 經度，浮點數，範圍為180 ~ -180
            // console.log('获取的', that.longitude)
            that.createScript()
            that.getMapMarkListOption()
          }
        })
      } else {
        console.log('加载mpay')
        this.loadMpayScript(this.mpReady) // 全局混入的函数
      }
    },
    scanQRCode () {
      let that = this
      if (window.mp) {
        mp.scanQRCode({
          needResult: 1, // needResult 接收參數 1 是否需要结果 0 不需要结果
          success: function (res) {
            // console.log('扫码结果', res)
            let resstr = res.result.slice((res.result.length - 10))
            // console.log(resstr)
            that.$store.commit('qrcode', resstr)
            that.onCode()
          }// 掃描結果回調gMapContext.getCenter()
        })
      } else {
        this.loadMpayScript(this.scanQRCode) // 全局混入的函数
      }
    },
    // 上面地圖移動結束事件回調函數
    mapCenterChanged () {
      // console.log('地图中心点', gMapContext.getCenter())
      if (gMapContext) {
        let centerpoint = gMapContext.getCenter()
        this.latitude = centerpoint.lat
        this.longitude = centerpoint.lng
      }
    },
    moveMap () {
      // console.log('移動地圖', gMapContext)
      if (gMapContext) {
        // console.log('移動地圖度數', this.latitude, this.longitude)
        gMapContext.setCenter({ lat: Number(this.latitude), lng: Number(this.longitude) })
      }
    },
    // 點擊地圖標記
    // clickMarker (markeritem) {
    //   console.log('markeritem', markeritem)
    // },
    // 頭部主頁圖標按鈕
    goHome () {
      this.$store.commit('qrcode', '')
      // console.log('ditu', gMapContext)
      this.isScan = false
      // this.mpReady()
    },
    getLocation () {
      if (navigator.geolocation) {
        let that = this
        navigator.geolocation.getCurrentPosition(
          function (res) {
            console.log('浏览器定位', res)
            that.latitude = res.coords.latitude
            that.longitude = res.coords.longitude
            that.createGScript()
            that.getMapMarkListOption()
          },
          err => {
            console.log('geolocation fail', err)
          }
        )
      } else {
        alert('Your browser does not support positioning')
      }
    }
  },
  created () {
    let inviteCode = this.$route.query.inviteCode
    // console.log('url: ', window.location.href)
    let mpayCode = this.$route.query.code
    let qrCode = this.qrcode || this.$route.query.qrcode
    // console.log('mpayCode', mpayCode)
    console.log('browser', this.browser)
    if (qrCode) {
      this.$store.commit('qrcode', qrCode)
      if (this.user) {
        this.onCode()
      } else {
        this.$router.push('/login')
      }
    }
    if (inviteCode) {
      if (this.browser === 'wechat') {
        this.$router.push(`/wechat_guide?inviteCode=${inviteCode}`)
      } else {
        this.$store.commit('inviteCode', inviteCode)
        this.$router.push('/login')
      }
    }
    if (this.browser === 'mpay') {
      if (mpayCode) {
        this.$store.commit('mpayCode', mpayCode)
      } else if (this.user) {
        // this.loadUser()
      }
    }

    // this.isBtns = true
    // scheme协议

    // this.$nextTick(() => {
    //   console.log(process.env.VUE_APP_SCHEME)
    //   window.location.href = process.env.VUE_APP_SCHEME
    // })

    // if (!this.isBtns && this.code) {
    //   this.onCode()
    // }
    if (this.user) {
      this.getOrderCount()
    }
    if (this.browser === 'mpay') {
      this.mpReady()
    } else {
      // this.getLocation()
    }
    window.initMap = this.initMap
  },
  mounted () {
    // this.createScript()
  }
}
</script>

<style lang="less">
.home-warp {
  position: relative;
  z-index: 878;
  .banner {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #fff;
    background: url("../assets/imgs/banner-home.jpg") no-repeat center;
    background-size: cover;
  }
  &-main {
    width: 100%;
    height: calc(100vh - 454px);
    min-height: 800px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;
    border-radius: 40px 40px 0 0;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  }
  &-block {
    display: flex;
    justify-content: center;
    align-items: center;
    &::after {
      content: " ";
      height: 8px;
      width: 80px;
      margin: 20px;
      border-radius: 4px;
      background: #cccccc;
    }
  }
  &-cont {
    padding: 0 48px;
    max-height: 60%;
    overflow-y: scroll;
  }
  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 48px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
  &-jifei {
    padding: 60px 0 20px;
    font-size: 36px;
    font-weight: 600;
    span {
      font-size: 60px;
    }
  }
  &-tip {
    font-size: 24px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    color: #999999;
  }
  &-row {
    display: flex;
    font-size: 24px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    color: #999999;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }
  &-col {
    display: flex;
    flex-direction: column;
    font-size: 24px;
    justify-content: flex-start;
    align-items: start;
    color: #999999;
    h3 {
      margin: 5px 0;
    }
    p {
      margin: 5px auto 10px;
      width: 95%;
    }
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }
  &-btn {
    position: fixed;
    left: 48px;
    right: 48px;
    bottom: 0;
    button {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
    }
  }
  &-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    font-size: 28px;
    color: #666666;
    padding: 20px 0;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
.home-bg {
  width: 100%;
}
.home-btns {
  // display: flex;
  padding: 0 20px;
  div {
    width: 30%;
    flex: 1;
    margin: 20px;
    background: #b8045b;
    color: #ffffff;
    padding: 20px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
  .googlepaly{
    width: 60%;
    margin: 20px auto;
    padding: 30px;
    background:linear-gradient(0deg, #ff80be, #b8045b, #d15692);
    border: solid 4px #b8045b;
    box-shadow:#b8045b 0px 0px 18px inset;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
  .appstore{
    width: 60%;
    margin: 20px auto;
    padding: 30px;
    background:linear-gradient(0deg, #ff80be, #b8045b, #d15692);
    border: solid 4px #b8045b;
    box-shadow:#b8045b 0px 0px 18px inset;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
  .hwstore{
    width: 60%;
    margin: 20px auto;
    padding: 30px;
    background:linear-gradient(0deg,#44c0ff,#00a4f9,#44c0ff);
    border: solid 4px #0583da;
    box-shadow:#0fd2fe 0px 0px 18px inset;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
.go-code {
  text-align: center;
  color: #67c23a;
  text-decoration: underline;
  padding: 10px 0 30px;
}
.home-body{
  padding-bottom: 1.9rem;
  .map-container{
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    .huawei-map{
      height: 100%;
    }
    .google-map{
      height: 100%;
    }
  }
  .icon_home_location{
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
    bottom: 5%;
    left: 3%;
  }
  .home_scan{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 100px;
    background: linear-gradient(180deg, rgb(87, 172, 221), rgb(73, 161, 219));
    border-radius: 50px;
    color: #fff;
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    .icon_home_scan{
      display: block;
      width: .5rem;
      height: .5rem;
      margin-right: 20px;
    }
  }
}
.home-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
}
.home-foot-tips {
  color: #333;
  text-align: center;
  padding: 20px 0 0;
}
.openothermask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: #fff;
  img {
    position: absolute;
    top: 3%;
    right: 5%;
    width: 35%;
  }
  p {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-40%);
    width: 100%;
    text-align: center;
    color: red;
  }
}
</style>
